module.exports = __webpack_public_path__ + "img/mail.53768fcf.png";